import { render } from "./FormPTSAutozalog.vue?vue&type=template&id=4c2d1c12&scoped=true"
import script from "./FormPTSAutozalog.vue?vue&type=script&lang=js"
export * from "./FormPTSAutozalog.vue?vue&type=script&lang=js"

import "./FormPTSAutozalog.vue?vue&type=style&index=0&id=4c2d1c12&scoped=true&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=1&id=4c2d1c12&scoped=true&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=2&id=4c2d1c12&scoped=true&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=3&id=4c2d1c12&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=4&id=4c2d1c12&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=5&id=4c2d1c12&scoped=true&lang=css"
import "./FormPTSAutozalog.vue?vue&type=style&index=6&id=4c2d1c12&lang=scss"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2d1c12"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QAvatar,QField,QSelect,QSpinner,QCheckbox,QInput,QRadio,QDialog,QBtn});
